<style>
.layout.row {
  margin-bottom: 20px !important;
}
</style>

<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12 style="text-align:right">
          <h3 style="float:left">Свойства вопроса: {{ questionId }}</h3>
          <v-btn color="pink" dark small fab @click="editOpen()">
            <v-icon>add</v-icon>
          </v-btn>
          <v-btn color="blue" dark small fab @click="refresh()">
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-flex>
        <v-flex sm12>
          <b><i>{{ questionParams.name }}</i></b>
        </v-flex>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field flat solo prepend-icon="search" placeholder="Поиск" v-model="search" hide-details
                class="hidden-sm-and-down">
              </v-text-field>
              <v-btn icon>
                <v-icon>filter_list</v-icon>
              </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table :headers="complex.headers" :search="search" :items="questionPropertyData"
                :rows-per-page-items="[10, 25, 50, 100]" class="elevation-1" item-key="propertyId"
                no-results-text="Нет результатов" rows-per-page-text="На странице" v-model="complex.selected">
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.propertyId }}</td>
                  <td>{{ propertyMap.get(props.item.propertyId) ? propertyMap.get(props.item.propertyId) : '--' }}</td>
                  <td>{{ props.item.propertyValue }}</td>
                  <td>{{ props.item.isActive == true ? "Да" : "Нет" }}</td>
                  <td>
                    <v-btn depressed outline icon fab dark color="primary" small @click="editOpen(props.item)">
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn depressed outline icon fab dark color="pink" small @click="removeItemConfirm(props.item)">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>

              <!-- Редактирование -->
              <div slot="widget-content">

                <v-dialog v-model="popupEdit.isOpen" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline" v-if="editedIndex.propertyIdForCompositeIndex !== null">
                        Редактирование
                      </span>
                      <span class="headline" v-if="editedIndex.propertyIdForCompositeIndex === null">
                        Добавление
                      </span>
                    </v-card-title>
                    <v-card-text>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-layout row v-if="readonlyFields">
                          <v-flex xs4>
                            <v-subheader>ID вопроса</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field label="ID вопроса" v-model="questionId" readonly></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row v-if="readonlyFields">
                          <v-flex xs4>
                            <v-subheader>ID свойства</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field label="ID свойства" v-model="modalData.propertyId" :rules="rules.required"
                              required readonly></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Cвойство вопроса</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field label="Cвойство вопроса" v-model="checkedPropertyName" :rules="rules.required"
                              required readonly @click="checkOpen()"></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Значение свойства</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field label="Значение свойства" v-model="modalData.propertyValue"
                              :rules="rules.propertyValue" required></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Активно</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-switch v-model="modalData.isActive"></v-switch>
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn flat @click="editCancel()">Закрыть</v-btn>
                      <v-btn color="primary" flat @click="submit()">Сохранить</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

              </div>


              <!-- Список свойств, доступных для типа данных выбранного вопроса -->
              <div slot="widget-content">
                <v-dialog v-model="popupCheck.isOpen" persistent width="calc(100vw - 100px)" height="600px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">
                        Выбор свойства
                      </span>
                    </v-card-title>
                    <v-card-text>
                      <v-data-table :headers="modalComplex.headers" :items="propertyListByQuestionDataType"
                        :rows-per-page-items="[10, 25, 50, 100]" class="elevation-1" item-key="id"
                        no-results-text="Нет результатов" rows-per-page-text="На странице"
                        v-model="modalComplex.selected">
                        <template slot="items" slot-scope="props">
                          <td>{{ props.item.id }}</td>
                          <td>{{ props.item.name }}</td>
                          <td>{{ props.item.code }}</td>
                          <td>{{ dataTypeMap.get(props.item.dataType) ? dataTypeMap.get(props.item.dataType) : '--' }}
                          </td>
                          <td>
                            <v-btn flat color="grey darken-1" @click="propertyCheck(props.item)">
                              Выбрать
                            </v-btn>
                          </td>
                        </template>
                      </v-data-table>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn flat @click="checkCancel()">Закрыть</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>

              <!-- Удаление -->
              <div slot="widget-content">
                <v-dialog v-model="popupRemove.isOpen" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Вы уверены что хотите удалить связь у этого вопроса?</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click.native="popupRemove.isOpen = false">Отмена</v-btn>
                      <v-btn color="blue darken-1" flat @click.native="actionRemove(modalData);">Да, уверен</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>

            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>

export default {
  data() {
    return {
      questionId: +this.$route.params.id,
      questionParams: this.$store.state.pollQuests.questionParams,
      // Название выбранного свойства
      checkedPropertyName: '',
      modalData: {},
      oldModalData: {},
      // Составной индекс "questionId-propertyId"
      editedIndex: {
        questionIdForCompositeIndex: null,
        propertyIdForCompositeIndex: null
      },
      valid: true,
      readonlyFields: true,
      rules: {
        required: [v => !!v || 'Обязательное поле'],
        propertyValue: [
          v => !!v || 'Значение не может быть пустым',
          v => typeof v !== 'undefined' && v.split(' ').length === 1 || 'Нельзя использовать пробелы', // Проверка на undefined исключает ошибку, когда релевантных данных нет
        ],
      },
      search: '',
      popupRemove: {
        isOpen: false
      },
      popupEdit: {
        isOpen: false,
        isEditing: false,
      },
      popupCheck: {
        isOpen: false,
      },
      complex: {
        selected: [],
        headers: [
          {
            text: 'ID',
            value: 'propertyId'
          },
          {
            text: 'Наименование',
            value: 'propertyName'
          },
          {
            text: 'Значение',
            value: 'propertyValue'
          },
          {
            text: "Активно",
            value: "isActive"
          },
          {
            text: 'Действия',
            value: ''
          }
        ],
      },
      modalComplex: {
        selected: [],
        headers: [
          {
            text: 'ID свойства',
            value: 'id'
          },
          {
            text: 'Название свойства',
            value: 'name'
          },
          {
            text: 'Внешний ключ',
            value: 'code'
          },
          {
            text: 'Тип данных',
            value: 'dataType'
          },
          {
            text: "Действия",
            value: ''
          }
        ],
      }
    };
  },

  mounted: function () {
    /**
     * Загружаем данные по связям "вопрос - свойство"
     */
    this.refresh();

    /**
     * Если список свойств пуст, то загружаем и его тоже
     */
    if (this.$store.getters["property/propertyData"].length === 0) {
      this.$store._actions["property/getPropertyData"][0]();
    }
  },

  computed: {
    /**
     * Данные по связям "вопрос - свойство"
     * @returns {default.computed.questionPropertyData|(function())|Array|getters.questionPropertyData}
     */
    questionPropertyData() {
      return this.$store.getters['questionProperty/questionPropertyData'];
    },

    /**
     * Данные по свойствам
     * @returns {default.computed.propertyListByQuestionDataType|(function())|Array|getters.propertyListByQuestionDataType}
     */
    propertyListByQuestionDataType() {
      return this.$store.getters['questionProperty/propertyListByQuestionDataType'];
    },


    /**
     * Объект Map, содержащий пары "dataTypeId-dataTypeName"
     * @returns {default.computed.dataTypeMap|(function())|Array|getters.dataTypeList}
     */
    dataTypeMap() {
      let result = new Map();

      this.$store.getters['dataType/dataTypeList'].forEach(dataType => {
        result.set(dataType.value, dataType.text);
      })

      return result;
    },

    /**
     * Объект Map, содержащий пары "propertyId-propertyname"
     */
    propertyMap() {
      let result = new Map();

      this.$store.getters['property/propertyData'].forEach(property => {
        result.set(property.id, property.name);
      })

      return result;
    },
  },

  methods: {
    /**
     * Обновление данных по связям "вопрос - свойство" и свойствам
     */
    refresh() {
      this.$store._actions['questionProperty/getQuestionPropertyListByQuestionId'][0]({ questionId: this.questionId });
      this.$store._actions['questionProperty/getPropertyListByQuestionDataType'][0]({ dataType: this.questionParams.dataType });
    },

    /**
     * Открытие модального окна с редактированием, сохраняем старые данные и индекс элемента на случай отмены редактирования
     * @param questionPropertyItem
     */
    editOpen(questionPropertyItem) {
      // Если редактирование
      if (questionPropertyItem !== null && typeof questionPropertyItem !== 'undefined') {
        this.modalData = questionPropertyItem;
        this.oldModalData = Object.assign({}, questionPropertyItem);
        this.editedIndex = {
          questionIdForCompositeIndex: questionPropertyItem.questionId,
          propertyIdForCompositeIndex: questionPropertyItem.propertyId
        };
        this.readonlyFields = true;
        this.checkedPropertyName = this.propertyMap.get(questionPropertyItem.propertyId);
        // Если добавление
      } else {
        this.modalData = {
          questionId: this.questionId,
          propertyId: '',
          propertyValue: '',
          isActive: true,
        };

        this.oldModalData = {};
        this.editedIndex = {
          questionIdForCompositeIndex: this.questionId,
          propertyIdForCompositeIndex: null
        };
        this.readonlyFields = false;
        this.checkedPropertyName = '';
      }

      this.popupEdit.isOpen = true;
    },

    /**
     * Отмена редактирования
     */
    editCancel() {
      if (this.editedIndex.propertyIdForCompositeIndex !== null) {
        const uneditedQuestionPropertyItem = this.questionPropertyData.find((el) => {
          return el.questionId === this.editedIndex.questionIdForCompositeIndex && el.propertyId === this.editedIndex.propertyIdForCompositeIndex;
        });

        Object.assign(uneditedQuestionPropertyItem, this.oldModalData);
      }

      this.popupEdit.isOpen = false;
      this.checkedPropertyName = '';
    },

    /**
     * Открытие модального окна для выбора свойства вопроса только при добавлении нового элемента
     */
    checkOpen() {
      if (this.editedIndex.propertyIdForCompositeIndex === null) {
        this.popupCheck.isOpen = true;
      } else {
        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Для редактирования доступны только значение и активность!');
      }
    },

    /**
     * Закрыть окно выбора свойства
     */
    checkCancel() {
      this.popupCheck.isOpen = false;
    },

    /**
     * Выбираем свойство
     * @param item
     */
    propertyCheck(item) {
      if (typeof this.questionPropertyData.find(qp => qp.propertyId === item.id) !== 'undefined') {
        return window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Такая связь "вопрос-свойство" существует!');
      }

      this.modalData.propertyId = item.id;
      this.checkedPropertyName = item.name;
      this.popupCheck.isOpen = false;
    },

    /**
     * Сохранение отредактированного элемента
     */
    submit() {
      if (this.$refs.form.validate()) {
        this.$store._actions['questionProperty/saveQuestionPropertyData'][0]({ compositeIndex: this.editedIndex, data: this.modalData }).then(() => {
          this.popupEdit.isOpen = false;
          this.checkedPropertyName = '';
        })
      }
    },

    /**
     * Открытие модального окна с подтверждением удаления
     * @param data
     */
    removeItemConfirm(data) {
      this.modalData = data;
      this.popupRemove.isOpen = true;
    },

    /**
     * Удаление элемента
     * @param item
     */
    actionRemove(item) {
      this.$store._actions['questionProperty/removeQuestionPropertyData'][0]({ item: item });
      this.popupRemove.isOpen = false;
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/ui/QuestionProperty.vue